import { type BaseQLSelectionSet, selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { MitarbeiterDaten } from '../../users/employees/entities/mitarbeiter-daten.js';
import type { Person } from '../../users/entities/person.js';
import { ProfilDaten } from '../../users/profile/entities/ProfilDaten.js';

export const PERSON_DOCUMENT_SELECTIONSET = {
  debitorennummer: 1,
  kreditorenNr: 1,
  nameAbbreviation: 1,
  profilDaten: selectionSet(() => ProfilDaten, 2),
  mitarbeiterDaten: selectionSet(() => MitarbeiterDaten, 5),
} satisfies BaseQLSelectionSet<Person>;
